import * as React from 'react';
import { useActions } from '../../state';
import { BoardMemberSummary } from '../BoardMemberSummary';
import { CeoSummary } from '../CeoSummary';
import { Section } from '../Section';
import { Button } from '../buttons';
import { SectionHeading } from '../section-heading';

export const SimpleBoardSummary: React.FC = () => {
  const { editorActions } = useActions();
  const onClick = () => {
    editorActions.setEditableBoard(true);
  };

  return (
    <Section>
      <SectionHeading>Styre og daglig leder</SectionHeading>
      <BoardMemberSummary />
      <CeoSummary />
      <Button level="secondary" onClick={onClick}>
        Gjør endringer i rollene
      </Button>
    </Section>
  );
};
